(function ($) {
	'use strict';

	$(document).ready(function() {
		initialize_menuMain();
	});

	function initialize_menuMain() {
		const $html = $('html');
		const $mainMenu = $('.main-menu');
		const $globalSubmenus = $('.main-menu__submenu-container', $mainMenu);
		const $submenuToggles = $('.main-menu__subnav-trigger', $mainMenu);
		const $thirdLevelToggles = $('.main-menu__thirdnav-trigger', $mainMenu);
		const $mobileMenuToggle = $('.main-menu__toggle');
		let hoverTimeout;
		let currentHoveredElement;

		$globalSubmenus.addClass('ready');

		// Desktop behavior
		if ($(window).width() >= 1000) {
			$('.menu-item__has-children').hover(
				function () {
					// Mouse enter
					$(this).addClass('submenu--revealed');
					if ($('.submenu--revealed').length > 0) {
						$html.addClass('submenu-is-open');
					}
				},
				function () {
					// Mouse leave
					$(this).removeClass('submenu--revealed');
					if ($('.submenu--revealed').length === 0) {
						$html.removeClass('submenu-is-open');
					}
				}
			);

			$('.main-menu__list-item--subnav.menu-item-has-children').hover(
				function () {
					clearTimeout(hoverTimeout);
					hidePreviousHoveredElement();

					currentHoveredElement = $(this);
					currentHoveredElement
						.attr('aria-expanded', 'true')
						.find('.dropdown-menu')
						.addClass('hover')
						.css('display', 'flex');
				},
				function () {
					currentHoveredElement = $(this);

					// Set a timeout only when hovering stops
					hoverTimeout = setTimeout(function () {
						currentHoveredElement
							.attr('aria-expanded', 'false')
							.find('.dropdown-menu')
							.removeClass('hover')
							.css('display', 'none');
					}, 500);
				}
			);

			function hidePreviousHoveredElement() {
				if (currentHoveredElement) {
					currentHoveredElement
						.attr('aria-expanded', 'false')
						.find('.dropdown-menu')
						.removeClass('hover')
						.css('display', 'none');
				}
			}
		}

		// Submenu toggles
		$submenuToggles.on('click', function (evt) {
			evt.preventDefault();
			evt.stopPropagation();

			const $thisParent = $(this).parent();
			const $thisSubmenu = $thisParent.next('.main-menu__submenu-container');

			// Desktop
			if ($mobileMenuToggle.css('display') === 'none') {
				if (!$(this).parents('.submenu--revealed').length) {
					$(this).parents('.main-menu__item').attr('aria-expanded', true);
					$mainMenu.find('.submenu--revealed')
						.removeClass('submenu--revealed')
						.attr('aria-expanded', false);
					$mainMenu.find('.main-menu__submenu-container.active')
						.removeClass('active')
						.hide();
					$html.addClass('submenu-is-open');
				} else {
					$(this).parents('.main-menu__item').attr('aria-expanded', false);
					$html.removeClass('submenu-is-open');
				}

				$(this).parents('.main-menu__item').toggleClass('submenu--revealed');
				$thisSubmenu.toggle().toggleClass('active');
			}

			// Mobile
			else {
				if (!$(this).parents('.submenu--revealed').length) {
					$(this).parents('.main-menu__item').attr('aria-expanded', true);
					$mainMenu.find('.submenu--revealed')
						.removeClass('submenu--revealed')
						.attr('aria-expanded', false);
					$mainMenu.find('.main-menu__submenu-container.active').slideUp();
					$('.thirdnav-menu').slideUp();
					$thirdLevelToggles.removeClass('active');
				} else {
					$(this).parents('.main-menu__item').attr('aria-expanded', false);
				}

				$(this).parents('.main-menu__item').toggleClass('submenu--revealed');
				$thisSubmenu.slideToggle().toggleClass('active');
			}
		});

		// Third level toggles
		$thirdLevelToggles.on('click', function (evt) {
			evt.preventDefault();
			evt.stopPropagation();

			$(this).toggleClass('active')
				.parent().next('.thirdnav-menu').slideToggle();
		});
	}
})(jQuery);
